import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 38,
  height: 23,
}

const airConditioner = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 37.914 23'
  >
    <g fill={color} transform='translate(0 -100.486)'>
      <path d='M35.249,100.486H9.015a.557.557,0,1,0,0,1.113H35.249a1.553,1.553,0,0,1,1.552,1.552V115a1.553,1.553,0,0,1-1.552,1.552H33.916v-3.626a.557.557,0,0,0-.557-.557H4.554a.557.557,0,0,0-.557.557v3.626H2.665A1.553,1.553,0,0,1,1.113,115v-11.85A1.553,1.553,0,0,1,2.665,101.6H6.788a.557.557,0,1,0,0-1.113H2.665A2.668,2.668,0,0,0,0,103.151V115a2.668,2.668,0,0,0,2.665,2.665H8.458a.557.557,0,1,0,0-1.113H5.111v-.978H27.229a.557.557,0,0,0,0-1.113H5.111v-.978H32.8v.978H29.455a.557.557,0,1,0,0,1.113H32.8v.978H10.684a.557.557,0,1,0,0,1.113H35.249A2.668,2.668,0,0,0,37.914,115v-11.85A2.668,2.668,0,0,0,35.249,100.486Z' />
      <path
        d='M422.063,147.58a.557.557,0,1,0,0-1.113h-1.646a.557.557,0,0,0,0,1.113Z'
        transform='translate(-388.703 -42.569)'
      />
      <path
        d='M254.774,147.58a.557.557,0,0,0,0-1.113H244.24a.557.557,0,1,0,0,1.113Z'
        transform='translate(-225.6 -42.569)'
      />
      <path
        d='M111.732,352.064a.557.557,0,0,0-.557.557,3.676,3.676,0,0,1-1.562,2.764.557.557,0,1,0,.645.907,4.787,4.787,0,0,0,2.03-3.671A.557.557,0,0,0,111.732,352.064Z'
        transform='translate(-101.263 -232.909)'
      />
      <path
        d='M187.84,352.064a.557.557,0,0,0-.557.557v3.217a.557.557,0,1,0,1.113,0v-3.217A.557.557,0,0,0,187.84,352.064Z'
        transform='translate(-173.385 -232.909)'
      />
      <path
        d='M250.621,352.064a.557.557,0,0,0-.557.557v3.217a.557.557,0,0,0,1.113,0v-3.217A.557.557,0,0,0,250.621,352.064Z'
        transform='translate(-231.507 -232.909)'
      />
      <path
        d='M365,355.384a3.663,3.663,0,0,1-1.562-2.766.557.557,0,0,0-1.113,0,4.787,4.787,0,0,0,2.03,3.671.557.557,0,1,0,.645-.907Z'
        transform='translate(-335.44 -232.909)'
      />
      <path
        d='M309.183,352.064a.556.556,0,0,0-.557.557v3.217a.557.557,0,1,0,1.113,0v-3.217A.557.557,0,0,0,309.183,352.064Z'
        transform='translate(-285.724 -232.909)'
      />
    </g>
  </svg>
)

export default airConditioner
